// extracted by mini-css-extract-plugin
module.exports = {"tagList":"tags_component_tagList___JJgP","tagListItem":"tags_component_tagListItem__5E5wY"};